
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/home/services-section.kpa`,
      template: `<section class="services-section">
        <div class="wrapper">
            <hex-headline left text="Ihre Immobilie, unser Service:<br>Von Grün bis Grau, alles perfekt"></hex-headline>
            <div class="left">
                <p>
                    Von der <b>Pflege</b> Ihrer Grünflächen bis zur <b>Instandhaltung</b> - wir sorgen dafür, 
                    dass Ihre Immobilie stets in <b>Bestform</b> bleibt. Verlässlich, <b>professionell</b>, aus einer Hand.
                </p>
            </div>

            <div class="hex-map-field">
                <div class="objektpflege"><p>{{objektpflegeText}}</p></div>
                <div class="hausmeisterservice"><p>{{hausmeisterserviceText}}</p></div>
                <div class="instandhaltung"><p>{{instandhaltungText}}</p></div>

                <div class="hex-map-wrapper">
                    <div class="hex-map">
                        <hex-button href="/leistungen/objektpflege" text="OBJEKTPFLEGE" color="green" id="hex-objektpflege"></hex-button>
                        <hex-button href="/leistungen/hausmeisterservice" text="HAUSMEISTER<br>SERVICE" color="gray" id="hex-hausmeisterservice"></hex-button>
                        <hex-button href="/leistungen/instandhaltung" text="INSTANDHALTUNG" color="green" id="hex-instandhaltung"></hex-button>
                    </div>
                </div>

                <div class="hex-click objektpflege-click"></div>
                <div class="hex-click hausmeisterservice-click"></div>
                <div class="hex-click instandhaltung-click"></div>
            </div>
        </div>
    </section>`,
      style: `services-section {
  position: relative;
  z-index: 4;
}
services-section .services-section {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  margin-top: 96px;
  background-color: #f2f2f1;
}
services-section .services-section .wrapper {
  padding: 0;
  border: 0px solid cyan;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
services-section .services-section .wrapper div {
  position: relative;
}
services-section .services-section .wrapper div p {
  text-align: right;
}
services-section .services-section .wrapper div img {
  width: 100%;
  height: auto;
}
services-section .services-section .wrapper > div.right {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-end;
}
services-section .services-section .wrapper > div.left {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
}
services-section .services-section .wrapper > div.left p {
  text-align: left;
}
services-section .services-section .wrapper .hex-map-field {
  position: relative;
  border: 0px solid green;
  padding-top: 44px;
}
services-section .services-section .wrapper .hex-map-field p {
  text-align: left;
}
services-section .services-section .wrapper .hex-map-field a {
  position: absolute;
  bottom: 0;
  right: 0;
}
services-section .services-section .wrapper .hex-map-field > div:not(.hex-map-wrapper) {
  position: absolute;
  border: 0px solid red;
  text-align: left;
  z-index: 5;
}
services-section .services-section .wrapper .hex-map-field div.objektpflege {
  top: 90px;
  left: 0;
  width: 100%;
  padding: 0 0 0 190px;
}
services-section .services-section .wrapper .hex-map-field div.hausmeisterservice {
  top: 240px;
  left: 0;
  width: 100%;
  padding: 0 0 0 275px;
}
services-section .services-section .wrapper .hex-map-field div.instandhaltung {
  top: 390px;
  left: 0;
  width: 100%;
  padding: 0 0 0 190px;
}
services-section .services-section .wrapper .hex-map-field .hex-map-wrapper {
  position: relative;
  left: 0;
  border: 0px solid blue;
  width: 285px;
  height: 556px;
  overflow: hidden;
  margin: 0 auto;
}
services-section .services-section .wrapper .hex-map-field .hex-map-wrapper .hex-map {
  position: relative;
  left: -18px;
  border: 0px solid red;
  z-index: 4;
  width: 575px;
  height: 1000px;
  transform: scale(0.5566);
  transform-origin: left top;
}
services-section .services-section .wrapper .hex-map-field .hex-map-wrapper .hex-map hex-button {
  border: 0px solid orange;
  position: absolute;
}
services-section .services-section .wrapper .hex-map-field .hex-map-wrapper .hex-map #hex-hausmeisterservice {
  top: 300px;
  left: 170px;
}
services-section .services-section .wrapper .hex-map-field .hex-map-wrapper .hex-map #hex-instandhaltung {
  top: 600px;
  left: 0;
}
services-section .services-section .wrapper .hex-map-field .hex-click {
  position: absolute;
  width: 188px;
  height: 110px;
  z-index: 7;
  cursor: pointer;
}
services-section .services-section .wrapper .hex-map-field .hex-click::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(60deg);
}
services-section .services-section .wrapper .hex-map-field .hex-click::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(-60deg);
}
services-section .services-section .wrapper .hex-map-field .objektpflege-click {
  top: 100px;
  left: calc(50% - 95px - 47px);
}
services-section .services-section .wrapper .hex-map-field .hausmeisterservice-click {
  top: 268px;
  left: calc(50% - 95px + 47px);
}
services-section .services-section .wrapper .hex-map-field .instandhaltung-click {
  top: 436px;
  left: calc(50% - 95px - 47px);
}
@media (min-width: 500px) {
  services-section .services-section .wrapper .hex-map-field .hex-map-wrapper {
    left: 0;
    width: 410px;
    height: 800px;
  }
  services-section .services-section .wrapper .hex-map-field .hex-map-wrapper .hex-map {
    left: -25px;
    transform: scale(0.8);
  }
  services-section .services-section .wrapper .hex-map-field .hex-click {
    width: 270px;
    height: 157px;
  }
  services-section .services-section .wrapper .hex-map-field .objektpflege-click {
    top: 125px;
    left: calc(50% - 135px - 70px);
  }
  services-section .services-section .wrapper .hex-map-field .hausmeisterservice-click {
    top: 365px;
    left: calc(50% - 135px + 65px);
  }
  services-section .services-section .wrapper .hex-map-field .instandhaltung-click {
    top: 605px;
    left: calc(50% - 135px - 70px);
  }
}
@media (max-width: 729px) {
  services-section .services-section .wrapper .hex-map-field > div:not(.hex-map-wrapper, .hex-click) {
    display: none;
  }
}
@media (min-width: 730px) {
  services-section .services-section .wrapper .hex-map-field {
    padding-top: 44px;
  }
  services-section .services-section .wrapper .hex-map-field .hex-map-wrapper {
    margin: 0;
    width: 257px;
    height: 500px;
  }
  services-section .services-section .wrapper .hex-map-field .hex-map-wrapper .hex-map {
    left: -16px;
    transform: scale(0.5);
  }
  services-section .services-section .wrapper .hex-map-field .hex-click {
    width: 168px;
    height: 98px;
  }
  services-section .services-section .wrapper .hex-map-field .objektpflege-click {
    top: 95px;
    left: 0px;
  }
  services-section .services-section .wrapper .hex-map-field .hausmeisterservice-click {
    top: 245px;
    left: 85px;
  }
  services-section .services-section .wrapper .hex-map-field .instandhaltung-click {
    top: 395px;
    left: 0px;
  }
}
@media (min-width: 970px) {
  services-section .services-section .wrapper .hex-map-field div.objektpflege {
    top: 120px;
    left: 0;
    padding: 0 0 0 280px;
  }
  services-section .services-section .wrapper .hex-map-field div.hausmeisterservice {
    top: 330px;
    left: 0;
    padding: 0 0 0 400px;
  }
  services-section .services-section .wrapper .hex-map-field div.instandhaltung {
    top: 540px;
    left: 0;
    padding: 0 0 0 280px;
  }
  services-section .services-section .wrapper .hex-map-field .hex-map-wrapper {
    margin: 0;
    width: 365px;
    height: 700px;
  }
  services-section .services-section .wrapper .hex-map-field .hex-map-wrapper .hex-map {
    left: -16px;
    transform: scale(0.7);
  }
  services-section .services-section .wrapper .hex-map-field .hex-click {
    width: 236px;
    height: 137px;
  }
  services-section .services-section .wrapper .hex-map-field .objektpflege-click {
    top: 115px;
    left: 6px;
  }
  services-section .services-section .wrapper .hex-map-field .hausmeisterservice-click {
    top: 325px;
    left: 125px;
  }
  services-section .services-section .wrapper .hex-map-field .instandhaltung-click {
    top: 535px;
    left: 6px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {
        objektpflegeText: 'Ganz gleich ob <b>Gebäude</b> oder Außenanlage – wir pflegen Ihre Objekte mit Sorgfalt, System und Weitblick. Vom gepflegten <b>Eingangsbereich</b> über <b>Rasenflächen</b> und <b>Hecken</b> bis hin zu saisonaler Bepflanzung schaffen wir ein Umfeld, das überzeugt – <b>nachhaltig</b> und werterhaltend.',
        hausmeisterserviceText: 'Ein Haus, das funktioniert – innen wie außen. Unser <b>Hausmeisterservice</b> vereint Pflege, Wartung und schnelle Hilfe in einem starken Paket: Ob <b>Wegepflege</b>, <b>Winterdienst</b> oder technische Kontrolle – wir sind da, bevor etwas fehlt.',
        instandhaltungText: 'Mit einem Auge fürs Detail und dem Blick aufs Ganze sichern wir die <b>Funktionalität</b> und den <b>Werterhalt</b> Ihrer Immobilie. Von regelmäßigen <b>Kontrollen</b> über <b>Fugenpflege</b> bis hin zur Koordination kleiner <b>Sanierungsmaßnahmen</b> sorgen wir für reibungslose Abläufe und langlebige Substanz.',
    },
    events: [
        ['click', '.objektpflege-click', function (event) {
                if (window.innerWidth >= 730) {
                    router.navigate('/leistungen/objektpflege');
                }
                else {
                    dialog.createDialog(\`<h3>Grünpflege</h3><p>$-{this.objektpflegeText}</p><a href="/leistungen/objektpflege">mehr erfahren <i class="fa-solid fa-arrow-right"></i></a>\`, "modal");
                }
            }],
        ['click', '.hausmeisterservice-click', function (event) {
                if (window.innerWidth >= 730) {
                    router.navigate('/leistungen/hausmeisterservice');
                }
                else {
                    dialog.createDialog(\`<h3>Hausmeisterservice</h3><p>$-{this.hausmeisterserviceText}</p><a href="/leistungen/hausmeisterservice">mehr erfahren <i class="fa-solid fa-arrow-right"></i></a>\`, "modal");
                }
            }],
        ['click', '.instandhaltung-click', function (event) {
                if (window.innerWidth >= 730) {
                    router.navigate('/leistungen/instandhaltung');
                }
                else {
                    dialog.createDialog(\`<h3>Instandhaltung</h3><p>$-{this.instandhaltungText}</p><a href="/leistungen/instandhaltung">mehr erfahren <i class="fa-solid fa-arrow-right"></i></a>\`, "modal");
                }
            }],
    ],
};
 })()`
    };
  